import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_CLIENTS_ATTEMPT,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAILURE,
} from "../constants";

// getClients actions
const getClientsAttempt = () => ({
  type: GET_CLIENTS_ATTEMPT,
});

const getClientsSuccess = (payload: any) => ({
  type: GET_CLIENTS_SUCCESS,
  payload,
});

const getClientsFailure = (error: string) => ({
  type: GET_CLIENTS_FAILURE,
  payload: {
    error,
  },
});

export const getClientsRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
  dispatch(getClientsAttempt());

  const params2 = {
    entity: "clients",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => {
      res.data.data = res.data.data.map((x: any) => {
        return {...x, joined: `${x.clientId} - ${x.clientName}`}
      });
      return res.data;
    })
    .then((payload) => {
      dispatch(getClientsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getClientsFailure(error.message));
    });
};
